import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axiosinstance from '../../api/axiosinstance';
import JourneyWorkflow from './JourneyWorkflow';
import TechStackSection from './TechStackSection';
import ProgramDurationSection from './ProgramDurationSection';
import WhyChooseSection from './WhyChooseSection';
import IncludedCoursesSection from './IncludedCoursesSection';
import SEO from '../common/SEO';
import ProgramHighlightsSection from './ProgramHighlightsSection';
import LiveProjectsSection from './LiveProjectsSection';
import { UsersIcon, ChatIcon, MonitorIcon, AwardIcon, TargetIcon, BriefcaseIcon, TrendingUpIcon } from './programHighlightIcons';
import { FaHackerrank, FaLinkedin, FaGithub, FaVideo } from 'react-icons/fa';
import { SiMicrosoftexcel, SiMicrosoftword, SiMicrosoftpowerpoint, SiLeetcode, SiGrammarly, SiCanva } from 'react-icons/si';

const ESPRP_LIVE_FEATURES = [
  'Mock Company Simulations',
  'Aptitude Practice Sessions',
  'Mock Interview Environment',
  'Corporate Communication Drills',
  'Group Discussion Rounds',
  'Technical Assessment Practice',
  'Placement Drive Preparation',
];

const ESPRP_LIVE_PROJECTS = [
  { name:'Aptitude Practice Platform',     icon:'🔢' },
  { name:'Mock Interview System',          icon:'🎤' },
  { name:'Resume Builder Tool',            icon:'📄' },
  { name:'Corporate Assessment Portal',    icon:'📊' },
  { name:'Placement Readiness Dashboard',  icon:'🎯' },
  { name:'Communication Skills Trainer',   icon:'🗣️' },
];

const ESPRP_HIGHLIGHTS = [
  { label: 'Personalized Coaching',             icon: <UsersIcon /> },
  { label: 'Mock Interview Practice',           icon: <ChatIcon /> },
  { label: 'Aptitude & Soft Skills Training',   icon: <MonitorIcon /> },
  { label: 'Resume & LinkedIn Building',        icon: <AwardIcon /> },
  { label: 'Placement Readiness Assessment',    icon: <TargetIcon /> },
  { label: 'Industry Mentor Guidance',          icon: <BriefcaseIcon /> },
  { label: 'Career Growth & Placement Support', icon: <TrendingUpIcon /> },
]

const ESPRP_JOURNEY_STEPS = [
  { label: 'Enrollment',                icon: 'enroll',        color: '#4F46E5' },
  { label: 'Skill Assessment',          icon: 'assessment',    color: '#4F46E5' },
  { label: 'Communication Training',    icon: 'communication', color: '#4F46E5' },
  { label: 'Aptitude & Coding Practice',icon: 'training',      color: '#4F46E5' },
  { label: 'Mock Interviews',           icon: 'interview',     color: '#4F46E5' },
  { label: 'Resume Building',           icon: 'resume',        color: '#4F46E5' },
  { label: 'HR & Technical Rounds',     icon: 'review',        color: '#4F46E5' },
  { label: 'Certification',             icon: 'certificate',   color: '#4F46E5' },
  { label: 'Placement Support',         icon: 'placement',     color: '#4F46E5' },
];

const FEATURES = [
  {
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>,
    title: 'Written Test Training',
    desc: 'Aptitude, Soft Skills, Coding, Puzzles & Problem Analysis tailored to company hiring patterns.',
  },
  {
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>,
    title: 'Mock Interview Rounds',
    desc: 'HR, Technical & Managerial mock interviews with real-time feedback from industry professionals.',
  },
  {
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="12" y1="17" x2="8" y2="17"/></svg>,
    title: 'Resume Building',
    desc: 'Professional ATS-friendly resume crafting with keyword optimization and personal branding.',
  },
  {
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/><line x1="12" y1="2" x2="12" y2="5"/><line x1="12" y1="19" x2="12" y2="22"/><line x1="2" y1="12" x2="5" y2="12"/><line x1="19" y1="12" x2="22" y2="12"/></svg>,
    title: 'Career Guidance',
    desc: 'One-on-one counselling sessions to map your strengths to the right career path and companies.',
  },
  {
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
    title: 'Placement Support',
    desc: 'Direct company referrals, drive coordination and active follow-up until you are placed.',
  },
  {
    icon: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>,
    title: 'Soft Skills & Communication',
    desc: 'Group discussions, presentation skills and professional etiquette training for corporate readiness.',
  },
];

const ESPRP_TECHS = [
  { name: 'MS Excel',       color: '#217346', bg: '#F0FDF4', abbr: 'XL', icon: SiMicrosoftexcel },
  { name: 'MS Word',        color: '#2B579A', bg: '#EFF6FF', abbr: 'W', icon: SiMicrosoftword },
  { name: 'PowerPoint',     color: '#D24726', bg: '#FFF7ED', abbr: 'PPT', icon: SiMicrosoftpowerpoint },
  { name: 'Aptitude Tools', color: '#4F46E5', bg: '#EEF2FF', abbr: '∑' },
  { name: 'HackerRank',     color: '#2EC866', bg: '#F0FDF4', abbr: 'HR', icon: FaHackerrank },
  { name: 'LeetCode',       color: '#FFA116', bg: '#FFF7ED', abbr: 'LC', icon: SiLeetcode },
  { name: 'Resume Builder', color: '#0EA5E9', bg: '#F0F9FF', abbr: '📄' },
  { name: 'LinkedIn',       color: '#0A66C2', bg: '#EFF6FF', abbr: 'in', icon: FaLinkedin },
  { name: 'GitHub',         color: '#1F2328', bg: '#F8FAFC', abbr: 'Git', icon: FaGithub },
  { name: 'Grammarly',      color: '#15C39A', bg: '#ECFEFF', abbr: 'Gr', icon: SiGrammarly },
  { name: 'Canva',          color: '#00C4CC', bg: '#ECFEFF', abbr: 'Cv', icon: SiCanva },
  { name: 'Mock Interview AI', color: '#4F46E5', bg: '#EEF2FF', abbr: 'AI' },
  { name: 'Zoom/Meet',      color: '#2563EB', bg: '#EFF6FF', abbr: '🎥', icon: FaVideo },
  { name: 'and more...',    color: '#6B7280', bg: '#F9FAFB', abbr: '...' },
];

const ESPRP_DURATIONS = [
  {
    title: '3 Months Track', color: '#4F46E5', colorDark: '#4338CA', bg: '#EEF2FF',
    phases: [
      { name: 'Foundation Skills', duration: '1 Month', items: ['Communication', 'Aptitude', 'Resume Building'] },
      { name: 'Mock Interviews & Practice', duration: '1 Month', items: ['Technical Interviews', 'HR Interviews', 'Group Discussions'] },
      { name: 'Placement Drive Prep', duration: '1 Month', items: ['Company-Specific Prep', 'Soft Skills Polishing', 'Final Assessments'] },
    ],
    deliverables: ['ESPRP Certificate', 'Mock Interview Reports', 'Placement Readiness Score'],
  },
  {
    title: '6 Months Track', color: '#EA580C', colorDark: '#C2410C', bg: '#FFF7ED',
    phases: [
      { name: 'Communication & Soft Skills', duration: '2 Months', items: ['English Communication', 'Group Discussion', 'Presentation Skills'] },
      { name: 'Aptitude & Technical Prep', duration: '2 Months', items: ['Quantitative Aptitude', 'Logical Reasoning', 'Coding Practice'] },
      { name: 'Mock Interviews & Placement Prep', duration: '2 Months', items: ['Technical & HR Interviews', 'Company-Specific Prep', 'Final Assessments'] },
    ],
    deliverables: ['ESPRP Certificate', 'Mock Interview Reports', 'Placement Readiness Score', 'Industry Portfolio'],
  },
];

const MODULES = [
  { no: '01', title: 'Assessment Readiness', items: ['Quantitative Aptitude', 'Logical Reasoning', 'Verbal Ability', 'Coding Challenges', 'Puzzle Solving'] },
  { no: '02', title: 'Communication & Soft Skills', items: ['Business Communication', 'Group Discussion Practice', 'Presentation Skills', 'Email & Report Writing', 'Professional Etiquette'] },
  { no: '03', title: 'Interview Preparation', items: ['HR Interview Training', 'Technical Round Prep', 'Managerial Round Prep', 'Salary Negotiation', 'Body Language & Confidence'] },
  { no: '04', title: 'Resume & LinkedIn', items: ['ATS-Optimised Resume', 'LinkedIn Profile Setup', 'Portfolio Building', 'GitHub Profile Review', 'Personal Branding'] },
  { no: '05', title: 'Placement Drives', items: ['Company Registrations', 'Pre-placement Briefings', 'On-campus & Off-campus Drives', 'Offer Letter Guidance', 'Post-offer Onboarding Tips'] },
];

const MODES = [
  { label: 'Online', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><path d="M8 21h8M12 17v4"/></svg> },
  { label: 'Offline', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg> },
  { label: 'Hybrid', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#4338CA" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg> },
];

const ESPRP_WHY_CHOOSE = [
  { title: 'Personalized Coaching',   sub: '1-on-1 mentor guidance',           icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> },
  { title: 'Mock Interviews',         sub: 'Practice with real scenarios',     icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg> },
  { title: 'Aptitude & Soft Skills',  sub: 'Build a well-rounded profile',     icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> },
  { title: 'Placement Readiness',     sub: 'Be ready for any selection round', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg> },
  { title: 'Industry Mentors',        sub: 'Learn from working professionals', icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 00-2.91-.09z"/><path d="M12 15l-3-3a22 22 0 012-3.95A12.88 12.88 0 0122 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 01-4 2z"/></svg> },
  { title: 'Confidence Building',     sub: 'Stand out and grow faster',        icon: <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg> },
];

const FAQS = [
  { q: 'Who is ESPRP designed for?', a: 'Final year students, recent graduates, and early professionals who want to crack campus placements and corporate selection rounds with confidence.' },
  { q: 'How long is the program?', a: 'The program runs for 4–8 weeks depending on the mode chosen (online, offline, or hybrid). Intensive weekend batches are also available.' },
  { q: 'Do I need prior technical knowledge?', a: 'No. ESPRP is designed to work alongside your technical training. It focuses on employability skills that complement your domain knowledge.' },
  { q: 'Will I get placement assistance after the program?', a: 'Yes. Every ESPRP participant gets direct access to UPL\'s placement network — including company referrals, drive registrations, and follow-up support.' },
  { q: 'Is a certificate provided?', a: 'Yes, UPL issues a certified completion certificate upon successfully finishing the program, recognised by our 250+ hiring partners.' },
];

const ESPRPPage = () => {
  const [openFaq, setOpenFaq] = useState(null);
  const [courses, setCourses] = useState([]);
  useEffect(() => {
    axiosinstance.get('/api/category/all/4')
      .then(res => setCourses(res.data.filter(c => c.pdf_file_path)))
      .catch(() => {})
  }, []);

  return (
    <>
      <SEO
        title="ESPRP — Employment Skills & Placement Readiness Program"
        path="/programs/esprp"
        description="UPL Snipe's ESPRP — Employment Skills & Placement Readiness Program. Aptitude training, mock interviews, resume building, and direct placement support for job-ready graduates."
        keywords="ESPRP, employment skills program, placement readiness, job training, mock interviews, resume building, campus placement preparation"
      />
      <style>{`
        #esprp-page { font-family:'Inter','Segoe UI',sans-serif; }
        #esprp-hero { background:linear-gradient(135deg,#1E1B4B 0%,#312E81 50%,#3730A3 100%) !important; padding:72px 5% 64px !important; min-height:100vh !important; box-sizing:border-box !important; }
        #esprp-hero-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:1fr 420px; gap:56px; align-items:center; }
        #esprp-eyebrow { display:inline-block; font-size:11px; font-weight:800; letter-spacing:0.14em; color:rgba(255,255,255,0.65); background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.2); padding:4px 14px; border-radius:20px; margin-bottom:16px; text-transform:uppercase; }
        #esprp-title { font-size:clamp(28px,4vw,48px); font-weight:900; color:#fff; line-height:1.15; letter-spacing:-0.03em; margin:0 0 10px; }
        #esprp-title span { color:#A5B4FC; }
        #esprp-tagline { font-size:14px; color:#A5B4FC; font-weight:600; margin:0 0 14px; letter-spacing:0.02em; }
        #esprp-sub { font-size:15px; color:rgba(255,255,255,0.72); line-height:1.75; margin:0 0 28px; }
        #esprp-hero-btns { display:flex; gap:12px; flex-wrap:wrap; }
        .esprp-btn-primary { padding:12px 28px; background:#4F46E5; color:#fff; text-decoration:none; border-radius:10px; font-size:14px; font-weight:700; border:none; cursor:pointer; transition:background 0.2s; }
        .esprp-btn-primary:hover { background:#4338CA; color:#fff; }
        .esprp-btn-outline { padding:12px 28px; background:transparent; border:1.5px solid rgba(255,255,255,0.3); color:#fff; text-decoration:none; border-radius:10px; font-size:14px; font-weight:600; cursor:pointer; transition:all 0.2s; }
        .esprp-btn-outline:hover { border-color:#A5B4FC; color:#A5B4FC; }
        #esprp-hero-card { background:rgba(255,255,255,0.07); border:1px solid rgba(255,255,255,0.15); border-radius:16px; padding:28px; backdrop-filter:blur(8px); }
        #esprp-hero-card h3 { font-size:14px; font-weight:800; color:#A5B4FC; margin:0 0 16px; letter-spacing:0.06em; text-transform:uppercase; }
        .esprp-check-item { display:flex; align-items:flex-start; gap:10px; margin-bottom:12px; font-size:13.5px; color:rgba(255,255,255,0.85); line-height:1.5; }
        .esprp-check-dot { width:20px; height:20px; border-radius:50%; background:rgba(99,102,241,0.4); display:flex; align-items:center; justify-content:center; flex-shrink:0; margin-top:1px; }
        #esprp-stats { background:#0B1629 !important; padding:36px 5% !important; }
        #esprp-stats-inner { max-width:1100px; margin:0 auto; display:grid; grid-template-columns:repeat(4,1fr); }
        .esprp-stat { text-align:center; padding:12px; border-right:1px solid rgba(99,102,241,0.2); }
        .esprp-stat:last-child { border-right:none; }
        .esprp-stat-val { font-size:32px; font-weight:900; color:#818CF8; line-height:1; margin-bottom:5px; }
        .esprp-stat-lbl { font-size:12px; color:rgba(255,255,255,0.5); font-weight:500; }
        #esprp-features { background:#F5F3FF; padding:72px 5%; }
        #esprp-features-inner { max-width:1100px; margin:0 auto; }
        .esprp-section-eyebrow { display:inline-block; font-size:11px; font-weight:800; letter-spacing:0.14em; color:#4F46E5; background:#EDE9FE; border:1px solid #C4B5FD; padding:4px 14px; border-radius:20px; margin-bottom:14px; text-transform:uppercase; }
        .esprp-section-title { font-size:clamp(22px,3vw,34px); font-weight:900; color:#1E1B4B; line-height:1.2; letter-spacing:-0.02em; margin:0 0 40px; }
        .esprp-section-title span { color:#4F46E5; }
        #esprp-feat-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:24px; }
        .esprp-feat-card { background:#fff; border:1.5px solid #E0E7FF; border-radius:14px; padding:24px; transition:box-shadow 0.2s,border-color 0.2s; }
        .esprp-feat-card:hover { box-shadow:0 8px 32px rgba(79,70,229,0.12); border-color:#C4B5FD; }
        .esprp-feat-icon { width:52px; height:52px; border-radius:12px; background:#EDE9FE; display:flex; align-items:center; justify-content:center; margin-bottom:14px; }
        .esprp-feat-title { font-size:15px; font-weight:800; color:#1E1B4B; margin:0 0 8px; }
        .esprp-feat-desc { font-size:13px; color:#6B7280; line-height:1.65; margin:0; }
        #esprp-modules { background:#fff; padding:72px 5%; border-top:1px solid #E0E7FF; }
        #esprp-modules-inner { max-width:1100px; margin:0 auto; }
        #esprp-modules-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; margin-top:40px; }
        .esprp-mod-card { border:1.5px solid #E0E7FF; border-radius:14px; padding:22px; }
        .esprp-mod-no { font-size:11px; font-weight:800; color:#4F46E5; letter-spacing:0.1em; margin-bottom:8px; }
        .esprp-mod-title { font-size:15px; font-weight:800; color:#1E1B4B; margin:0 0 12px; }
        .esprp-mod-item { display:flex; align-items:center; gap:8px; font-size:12.5px; color:#475569; margin-bottom:7px; }
        #esprp-modes { background:#F5F3FF; padding:56px 5%; border-top:1px solid #E0E7FF; }
        #esprp-modes-inner { max-width:1100px; margin:0 auto; }
        #esprp-modes-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; margin-top:32px; }
        .esprp-mode-card { background:#fff; border:1.5px solid #C4B5FD; border-radius:14px; padding:28px; text-align:center; }
        .esprp-mode-icon { width:56px; height:56px; border-radius:50%; background:#EDE9FE; display:flex; align-items:center; justify-content:center; margin:0 auto 14px; }
        .esprp-mode-label { font-size:16px; font-weight:800; color:#1E1B4B; margin:0 0 8px; }
        .esprp-mode-desc { font-size:13px; color:#6B7280; margin:0; line-height:1.6; }
        #esprp-faq { background:#fff; padding:72px 5%; border-top:1px solid #E0E7FF; }
        #esprp-faq-inner { max-width:760px; margin:0 auto; }
        .esprp-faq-item { border:1.5px solid #E0E7FF; border-radius:12px; margin-bottom:12px; overflow:hidden; }
        .esprp-faq-q { display:flex; justify-content:space-between; align-items:center; padding:16px 20px; cursor:pointer; background:#fff; font-size:14px; font-weight:700; color:#1E1B4B; gap:12px; }
        .esprp-faq-q:hover { background:#FAFAFA; }
        .esprp-faq-a { padding:0 20px 16px; font-size:13.5px; color:#475569; line-height:1.7; }
        #esprp-cta { background:linear-gradient(135deg,#1E1B4B 0%,#312E81 100%) !important; padding:64px 5% !important; text-align:center; }
        #esprp-cta-inner { max-width:700px; margin:0 auto; }
        #esprp-cta h2 { font-size:clamp(22px,3vw,36px); font-weight:900; color:#fff; margin:0 0 14px; letter-spacing:-0.02em; }
        #esprp-cta p { font-size:15px; color:rgba(255,255,255,0.65); margin:0 0 28px; line-height:1.7; }
        #esprp-cta-btns { display:flex; gap:12px; justify-content:center; flex-wrap:wrap; }
        #esprp-why-choose { background:#1E1B4B !important; }
        @media(max-width:900px) { #esprp-hero { min-height:auto !important; } #esprp-hero-inner { grid-template-columns:1fr !important; } #esprp-hero-card { display:none !important; } #esprp-feat-grid,#esprp-modules-grid,#esprp-modes-grid,#esprp-delivery-grid { grid-template-columns:1fr 1fr !important; } #esprp-stats-inner { grid-template-columns:repeat(2,1fr) !important; } #esprp-dur-grid { grid-template-columns:1fr !important; } #esprp-why-grid { grid-template-columns:1fr !important; gap:32px !important; } #esprp-metric-grid { grid-template-columns:1fr 1fr !important; } }
        @media(max-width:560px) { #esprp-feat-grid,#esprp-modules-grid,#esprp-modes-grid,#esprp-delivery-grid { grid-template-columns:1fr !important; } #esprp-stats-inner { grid-template-columns:repeat(2,1fr) !important; } #esprp-metric-grid { grid-template-columns:1fr !important; } }
      `}</style>

      <div id="esprp-page">

        {/* HERO */}
        <section id="esprp-hero">
          <div id="esprp-hero-inner">
            <div>
              <div id="esprp-eyebrow">UPL Program</div>
              <h1 id="esprp-title">Employability Skills &<br /><span>Placement Readiness</span></h1>
              <div style={{ display:'inline-flex', alignItems:'center', background:'rgba(255,255,255,0.08)', border:'1px solid rgba(255,255,255,0.16)', borderRadius:999, padding:'7px 20px', margin:'12px 0 14px' }}>
                {['3 Months','6 Months','Offline','Online','Hybrid'].map((t,i,a) => (
                  <React.Fragment key={t}>
                    <span style={{ fontSize:13, fontWeight:700, color:'#fff' }}>{t}</span>
                    {i<a.length-1 && <span style={{ color:'rgba(255,255,255,0.35)', margin:'0 10px' }}>|</span>}
                  </React.Fragment>
                ))}
              </div>
              <p id="esprp-tagline">ESPRP — Train. Prepare. Get Placed.</p>
              <p id="esprp-sub">
                A focused program designed to make you interview-ready and placement-confident.
                We train students to crack written assessments, technical rounds, and HR interviews
                at top IT companies — with real mock sessions and direct placement support.
              </p>
              <div id="esprp-hero-btns">
                <button className="esprp-btn-primary" onClick={() => window.dispatchEvent(new CustomEvent('openApplyModal', { detail: { program: 'ESPRP' } }))}>
                  Enroll Now
                </button>
                <button className="esprp-btn-outline" onClick={() => document.getElementById('courses-section')?.scrollIntoView({ behavior:'smooth' })}>
                  View Courses
                </button>
              </div>
            </div>

            <div id="esprp-hero-card">
              <h3>What You Will Gain</h3>
              {[
                'Crack aptitude & coding assessments',
                'Ace HR, Technical & Managerial interviews',
                'Build an ATS-optimised resume',
                'Develop corporate communication skills',
                'Get placed via UPL\'s hiring network',
                'Receive a recognised completion certificate',
              ].map((item, i) => (
                <div className="esprp-check-item" key={i}>
                  <div className="esprp-check-dot">
                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#A5B4FC" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                  </div>
                  {item}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* STATS */}
        <section id="esprp-stats">
          <div id="esprp-stats-inner">
            {[
              { val: '5,000+', lbl: 'Students Placed' },
              { val: '250+',   lbl: 'Hiring Partners' },
              { val: '95%+',   lbl: 'Placement Rate' },
              { val: '4–8',    lbl: 'Weeks Program' },
            ].map(s => (
              <div className="esprp-stat" key={s.lbl}>
                <div className="esprp-stat-val">{s.val}</div>
                <div className="esprp-stat-lbl">{s.lbl}</div>
              </div>
            ))}
          </div>
        </section>

        {/* FEATURES — commented out
        <section id="esprp-features">
          <div id="esprp-features-inner">
            <div style={{ textAlign: 'center' }}>
              <div className="esprp-section-eyebrow" style={{ margin: '0 auto 14px' }}>Program Coverage</div>
              <h2 className="esprp-section-title">Everything You Need to <span>Get Placed</span></h2>
            </div>
            <div id="esprp-feat-grid">
              {FEATURES.map(f => (
                <div className="esprp-feat-card" key={f.title}>
                  <div className="esprp-feat-icon">{f.icon}</div>
                  <div className="esprp-feat-title">{f.title}</div>
                  <p className="esprp-feat-desc">{f.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        */}

        {/* PROGRAM HIGHLIGHTS */}
        <ProgramHighlightsSection
          items={ESPRP_HIGHLIGHTS}
          accentColor="#4F46E5"
          iconBg="#EEF2FF"
          iconBorder="#C7D2FE"
          cardBorder="#E0E7FF"
        />

        {/* COURSES */}
        <div id="courses-section">
          <IncludedCoursesSection courses={courses} programId={4} programName="ESPRP Program" bg="#EEF2FF" />
        </div>

        {/* PROGRAM STRUCTURE */}
        <section style={{ background:'linear-gradient(135deg,#EEF2FF 0%,#F5F3FF 100%)', padding:'64px 5%' }}>
          <div style={{ maxWidth:1100, margin:'0 auto' }}>

            {/* Eyebrow + Title */}
            <div style={{ textAlign:'center', marginBottom:44 }}>
              <div style={{ display:'inline-flex', alignItems:'center', background:'#fff', border:'1.5px solid #C4B5FD', borderRadius:999, padding:'6px 22px', fontSize:11, fontWeight:800, color:'#4F46E5', letterSpacing:'0.12em', textTransform:'uppercase', marginBottom:18 }}>Curriculum</div>
              <h2 style={{ fontSize:'clamp(26px,3.2vw,40px)', fontWeight:900, color:'#0F172A', margin:0 }}>
                Program <span style={{ color:'#4F46E5' }}>Structure</span>
              </h2>
            </div>

            {/* Metric cards */}
            <div id="esprp-metric-grid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:24, marginBottom:52 }}>
              {[
                { value:'80 Hours', label:'Per Academic Year', sub:'Annual Training Commitment' },
                { value:'40 Hours', label:'Per Semester',       sub:'Semester-Wise Delivery' },
              ].map(m => (
                <div key={m.label} style={{ background:'#fff', border:'1.5px solid #DDD6FE', borderRadius:18, padding:'28px 24px' }}>
                  <div style={{ fontSize:'clamp(32px,5vw,52px)', fontWeight:900, color:'#4F46E5', lineHeight:1, marginBottom:10 }}>{m.value}</div>
                  <div style={{ fontSize:16, fontWeight:800, color:'#1E293B', marginBottom:4 }}>{m.label}</div>
                  <div style={{ fontSize:13.5, color:'#64748B' }}>{m.sub}</div>
                </div>
              ))}
            </div>

            {/* Duration Options */}
            <h3 style={{ fontSize:20, fontWeight:800, color:'#0F172A', textAlign:'center', margin:'0 0 24px' }}>Program Duration Options</h3>
            <div id="esprp-dur-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:20 }}>
              {[
                { label:'1-Year Program', sub:'Suitable for Final Year Students',       color:'#3451D1', items:['2 Semesters','80 Hours Training','Placement-Focused Preparation'] },
                { label:'2-Year Program', sub:'Suitable for 2nd & Final Year Students', color:'#6C3FC8', items:['4 Semesters','160 Hours Training','Progressive Employability Development'] },
                { label:'3-Year Program', sub:'Suitable from First Year Onwards',       color:'#8B2FC9', items:['6 Semesters','240 Hours Training','Complete Employability Transformation'] },
              ].map(d => (
                <div key={d.label} style={{ background:'#fff', border:'1.5px solid #DDD6FE', borderRadius:16, overflow:'hidden' }}>
                  <div style={{ background:d.color, padding:'22px 26px' }}>
                    <div style={{ fontSize:20, fontWeight:900, color:'#fff' }}>{d.label}</div>
                    <div style={{ fontSize:12.5, color:'rgba(255,255,255,0.75)', marginTop:5 }}>{d.sub}</div>
                  </div>
                  <div style={{ padding:'22px 26px', display:'flex', flexDirection:'column', gap:14 }}>
                    {d.items.map(item => (
                      <div key={item} style={{ display:'flex', alignItems:'center', gap:10, fontSize:13.5, color:'#1E293B', fontWeight:500 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={d.color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                        {item}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* MODULES */}
        <section id="esprp-modules">
          <div id="esprp-modules-inner">
            <div style={{ textAlign: 'center' }}>
              <div className="esprp-section-eyebrow" style={{ margin: '0 auto 14px' }}>Curriculum</div>
              <h2 className="esprp-section-title">Program <span>Modules</span></h2>
            </div>
            <div id="esprp-modules-grid">
              {MODULES.map(m => (
                <div className="esprp-mod-card" key={m.no}>
                  <div className="esprp-mod-no">MODULE {m.no}</div>
                  <div className="esprp-mod-title">{m.title}</div>
                  {m.items.map(item => (
                    <div className="esprp-mod-item" key={item}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      {item}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* JOURNEY WORKFLOW */}
        <JourneyWorkflow title="ESPRP Journey Workflow" steps={ESPRP_JOURNEY_STEPS} accentColor="#4F46E5" />

        {/* TECHNOLOGY YOU WILL LEARN */}
        <TechStackSection title="Technology You Will Learn" accentColor="#4F46E5" bg="#EEF2FF" border="#E2E8F0" techs={ESPRP_TECHS} />

        {/* LIVE PROJECTS */}
        <LiveProjectsSection
          accentColor="#4F46E5"
          accentBg="#EEF2FF"
          accentBorder="#C7D2FE"
          title="Live Project Internship Experience"
          features={ESPRP_LIVE_FEATURES}
          projects={ESPRP_LIVE_PROJECTS}
        />

        {/* MODES */}
        <section id="esprp-modes">
          <div id="esprp-modes-inner">
            <div style={{ textAlign: 'center' }}>
              <div className="esprp-section-eyebrow" style={{ margin: '0 auto 14px' }}>Flexibility</div>
              <h2 className="esprp-section-title">Choose Your <span>Learning Mode</span></h2>
            </div>
            <div id="esprp-modes-grid">
              {[
                { ...MODES[0], desc: 'Live interactive sessions from the comfort of your home. Recorded backups available.' },
                { ...MODES[1], desc: 'In-person classroom training at our centre with hands-on group activities.' },
                { ...MODES[2], desc: 'Best of both worlds — attend online and visit the centre for mock drives & group sessions.' },
              ].map(m => (
                <div className="esprp-mode-card" key={m.label}>
                  <div className="esprp-mode-icon">{m.icon}</div>
                  <div className="esprp-mode-label">{m.label} Programs</div>
                  <p className="esprp-mode-desc">{m.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ══ WHY ESPRP ══ */}
        <section style={{ background:'#fff', padding:'72px 5%', borderTop:'1px solid #E0E7FF' }}>
          <div style={{ maxWidth:1100, margin:'0 auto' }}>
            <div id="esprp-why-grid" style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:56, alignItems:'center' }}>
              <div>
                <div className="esprp-section-eyebrow">Why ESPRP?</div>
                <h2 className="esprp-section-title">Bridging the <span>Employability Gap</span></h2>
                <p style={{ fontSize:15, color:'#475569', lineHeight:1.8, marginBottom:28 }}>
                  In today's dynamic job landscape, academic achievements alone no longer guarantee success. Employers now prioritize candidates who demonstrate strong communication, analytical thinking, aptitude, and interview readiness — essential skills that complement academic excellence.
                </p>
                <p style={{ fontSize:14, fontWeight:700, color:'#1E1B4B', marginBottom:16 }}>Many students face challenges due to:</p>
                {['Lack of Aptitude Preparation','Poor Communication Skills','Limited Interview Exposure','Insufficient Industry Awareness','Weak Problem-Solving Skills','Lack of Placement Readiness'].map(c => (
                  <div key={c} style={{ display:'flex', alignItems:'center', gap:10, fontSize:14, color:'#374151', marginBottom:10 }}>
                    <div style={{ width:20, height:20, borderRadius:'50%', background:'#EDE9FE', border:'1.5px solid #C4B5FD', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                    </div>
                    {c}
                  </div>
                ))}
              </div>
              <div style={{ background:'#F5F3FF', border:'1.5px solid #C4B5FD', borderRadius:20, padding:'36px 32px' }}>
                <h3 style={{ fontSize:16, fontWeight:800, color:'#4338CA', marginBottom:24, letterSpacing:'0.04em', textTransform:'uppercase' }}>UPL Addresses These Gaps Through</h3>
                {['Comprehensive semester-wise training framework','Structured aptitude & communication modules','Mock interviews & placement simulations','Resume building & LinkedIn optimization','Industry expert sessions & career guidance','Continuous progress tracking & assessments'].map((s, i) => (
                  <div key={s} style={{ display:'flex', alignItems:'flex-start', gap:12, marginBottom:14 }}>
                    <div style={{ width:28, height:28, borderRadius:8, background:'#4F46E5', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0, color:'#fff', fontSize:12, fontWeight:800 }}>{i+1}</div>
                    <span style={{ fontSize:14, color:'#374151', lineHeight:1.5, paddingTop:4 }}>{s}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* ══ TRAINING DELIVERY MODELS ══ */}
        <section style={{ background:'#fff', padding:'72px 5%', borderTop:'1px solid #E0E7FF' }}>
          <div style={{ maxWidth:1100, margin:'0 auto' }}>
            <div style={{ textAlign:'center', marginBottom:48 }}>
              <div className="esprp-section-eyebrow" style={{ margin:'0 auto 14px' }}>Flexibility</div>
              <h2 className="esprp-section-title">Training <span>Delivery Models</span></h2>
            </div>
            <div id="esprp-delivery-grid" style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:24 }}>
              {[
                { mode:'Online Mode', icon:'💻', accent:'#4F46E5', bg:'#EDE9FE', border:'#C4B5FD', items:['Live Virtual Sessions','Practice Assessments','Learning Portal Access'] },
                { mode:'Hybrid Mode', icon:'🔄', accent:'#7C3AED', bg:'#F5F3FF', border:'#DDD6FE', items:['Online Training','Campus Workshops','Expert Sessions'] },
                { mode:'On-Campus Training', icon:'🏫', accent:'#6D28D9', bg:'#EDE9FE', border:'#C4B5FD', items:['Classroom Delivery','Mock Assessments','Placement Preparation Workshops'] },
              ].map(m => (
                <div key={m.mode} style={{ background:m.bg, border:`1.5px solid ${m.border}`, borderRadius:16, padding:'32px 28px' }}>
                  <div style={{ fontSize:36, marginBottom:14 }}>{m.icon}</div>
                  <h3 style={{ fontSize:16, fontWeight:800, color:'#1E1B4B', marginBottom:18 }}>{m.mode}</h3>
                  {m.items.map(item => (
                    <div key={item} style={{ display:'flex', alignItems:'center', gap:10, fontSize:13.5, color:'#374151', marginBottom:10 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={m.accent} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                      {item}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* WHY CHOOSE OUR ESPRP PROGRAM */}
        <WhyChooseSection
          id="esprp-why-choose"
          title="WHY CHOOSE OUR ESPRP PROGRAM?"
          bg="#1E1B4B"
          iconColor="#A5B4FC"
          iconBg="rgba(79,70,229,0.15)"
          iconBorder="rgba(165,180,252,0.25)"
          items={ESPRP_WHY_CHOOSE}
        />

        {/* FAQ */}
        <section id="esprp-faq">
          <div id="esprp-faq-inner">
            <div style={{ textAlign: 'center', marginBottom: 36 }}>
              <div className="esprp-section-eyebrow" style={{ margin: '0 auto 14px' }}>FAQ</div>
              <h2 className="esprp-section-title">Common <span>Questions</span></h2>
            </div>
            {FAQS.map((f, i) => (
              <div className="esprp-faq-item" key={i}>
                <div className="esprp-faq-q" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  {f.q}
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4F46E5" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"
                    style={{ transform: openFaq === i ? 'rotate(45deg)' : 'rotate(0deg)', transition: 'transform 0.2s', flexShrink: 0 }}>
                    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                  </svg>
                </div>
                {openFaq === i && <div className="esprp-faq-a">{f.a}</div>}
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section id="esprp-cta">
          <div id="esprp-cta-inner">
            <div className="esprp-section-eyebrow" style={{ background: 'rgba(165,180,252,0.15)', color: '#A5B4FC', border: '1px solid rgba(165,180,252,0.3)', margin: '0 auto 16px' }}>Get Started</div>
            <h2>Ready to Crack Your Dream Company?</h2>
            <p>Join ESPRP and get the edge you need — assessments, interviews, resume and placement, all under one program.</p>
            <div id="esprp-cta-btns">
              <button className="esprp-btn-primary" style={{ padding: '13px 32px', fontSize: 15 }}
                onClick={() => window.dispatchEvent(new CustomEvent('openApplyModal', { detail: { program: 'ESPRP' } }))}>
                Enroll Now
              </button>
              <button className="esprp-btn-outline" onClick={() => document.getElementById('courses-section')?.scrollIntoView({ behavior:'smooth' })}>View Courses</button>
            </div>
          </div>
        </section>

      </div>
    </>
  );
};

export default ESPRPPage;
